import { render } from "./2024w_study.vue?vue&type=template&id=8f4c1636"
import script from "./2024w_study.vue?vue&type=script&lang=js"
export * from "./2024w_study.vue?vue&type=script&lang=js"

import exportComponent from "D:\\childu_lms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__